import { Tooltip } from 'antd';
import { LanguageIcon } from 'src/icons/language.icon';
import { useDispatch, useSelector } from 'react-redux';
import { updateCurrentPractitionerSettings } from 'src/store/actions/practitioner.action';
import { analytics } from 'src/services';
import { useAuth } from '@frontegg/react';

export const LanguageSelector = () => {
  const isMobileView = window.innerWidth < 1260;

  const dispatch = useDispatch();
  const { user } = useAuth();
  const { currentPractitionerSettings } = useSelector(
    (state) => state?.practitionerState
  );

  const handleMultilingualChange = () => {
    const currentValue =
      currentPractitionerSettings?.note_preferences?.multi_lingual;
    const newValue = !currentValue;

    const updatedSettings = {
      note_preferences: {
        ...currentPractitionerSettings?.note_preferences,
        multi_lingual: newValue,
      },
    };

    dispatch(updateCurrentPractitionerSettings(updatedSettings));
    analytics.track(
      `${
        newValue ? 'Enabled' : 'Disabled'
      } Multi-lingual Audio From Encounter Page`,
      { email: user?.email }
    );
  };

  const Languagelabel = (
    <span
      className="text-xs text-gray-500 cursor-pointer hover:text-[#00D090] transition-colors underline decoration-dotted"
      onClick={handleMultilingualChange}
    >
      {currentPractitionerSettings?.note_preferences?.multi_lingual
        ? 'Multi-lingual'
        : 'English'}
    </span>
  );

  return (
    <div className="flex items-center gap-1 px-3 py-2">
      <LanguageIcon onClick={handleMultilingualChange} />
      {isMobileView ? (
        Languagelabel
      ) : (
        <Tooltip
          title={
            <div>
              <div>
                Switch to multi-language mode to detect speech in the following
                languages:
              </div>
              <ul
                style={{
                  marginTop: '8px',
                  marginBottom: '8px',
                  paddingLeft: '16px',
                }}
              >
                <li>English</li>
                <li>Spanish</li>
                <li>French</li>
                <li>German</li>
                <li>Hindi</li>
                <li>Russian</li>
                <li>Portuguese</li>
                <li>Japanese</li>
                <li>Italian</li>
                <li>Dutch</li>
              </ul>
              <div>
                <strong>Note:</strong> This is not a translation service.
                Clinical notes will be generated in English.
              </div>
            </div>
          }
          placement="right"
        >
          {Languagelabel}
        </Tooltip>
      )}
    </div>
  );
};
